import {Component, input, computed} from '@angular/core';
import {MatButtonModule} from '@angular/material/button';
import {MatCardModule} from '@angular/material/card';
import {Nl2brPipe, TruncatePipe} from 'kkm-library';
import {RouterLink} from '@angular/router';
import {DatePipe} from '@angular/common';
import {LinkyModule} from 'ngx-linky';

import {Infocard} from '../modules/news/infocard';

@Component({
    selector: 'kkm-infocard',
    imports: [MatCardModule, MatButtonModule, RouterLink, DatePipe, LinkyModule, Nl2brPipe],
    templateUrl: './infocard.component.html',
    styleUrls: ['./infocard.component.scss'],
})
export class InfocardComponent {
    data = input.required<Infocard>();
    roundImage = input(false);
    truncate = input(false);

    text = computed(() => {
        if (this.truncate()) {
            return TruncatePipe.transform(this.data().text);
        }
        return this.data().text;
    });
}
